import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams, NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ReactComponent as ProductIcon } from 'assets/icons/barcode.svg'

import Select from 'util/modules/Form/Select'
import Upload, { UploadRef } from 'util/modules/Upload'

import { createAlert } from 'util/modules/Alert/redux/actions'
import { getCategoryList } from 'panel/category/redux/actions'
import { ApplicationState } from 'AppReducer'
import { createProduct, updateProduct, getProduct } from '../redux/actions'

const initialState = {
  isActive: true,
  isSellable: true,
  name: '',
  category: '',
  description: ''
}

const ProductForm: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { partnerId, id } = useParams<{ [x: string]: string }>()
  const { categoryList: { items: categories } } = useSelector((state: ApplicationState) => state.categoryReducer)

  const [picture, setPicture] = useState<File>()
  const uploadRef = useRef<UploadRef>(null)

  const [form, setForm] = useState(initialState)

  function handleClear (): void {
    uploadRef.current?.clear()
    setForm(initialState)
    history.push(`/panel/partner/${partnerId}/product`)
  }

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    try {
      const formData = new FormData()
      if (picture) {
        formData.set('picture', picture)
      }

      formData.set('isActive', form.isActive ? '1' : '0')
      formData.set('isSellable', form.isSellable ? '1' : '0')
      formData.set('name', form.name)
      formData.set('description', form.description)
      formData.set('category', form.category)

      if (partnerId && id) {
        updateProduct(partnerId, id, formData)(dispatch)
      } else {
        createProduct(partnerId, formData)(dispatch).then(res => {
          if (res?.status === 'success') {
            handleClear()
          }
        })
      }
    } catch (error) {
      createAlert({ code: 500, title: 'Oops', message: error.message })(dispatch)
    }
  }

  function fetchCategories (): void {
    getCategoryList({ fields: 'id,name', 'order[name]': 'ASC' })(dispatch)
  }

  useEffect(() => {
    fetchCategories()
  }, [dispatch])

  useEffect(() => {
    if (partnerId && id) {
      getProduct(partnerId, id)(dispatch).then(res => {
        const product = res?.data

        if (product) {
          setForm({
            isActive: product.isActive,
            isSellable: product.isSellable,
            category: product.category?.id.toString(),
            name: product.name,
            description: product.description || ''
          })

          uploadRef.current?.setPreviewImage(product.pictureMedium)
        } else {
          setForm(initialState)
          uploadRef?.current?.clear()
        }
      })
    }
  }, [partnerId, id, dispatch])

  return (
    <form className="row panel" onSubmit={handleSubmit}>
      <h2 className="row justify-start margin-bottom-16">
        <ProductIcon height="25" width="35" fill="var(--panel-text)" /> Gestão de Produto
      </h2>

      <div style={{ width: 170, height: 170 }}>
        <Upload
          ref={uploadRef}
          onChange={setPicture}
          placeholder="Selecionar imagem para Produto"
        />
      </div>

      <div className="row grow padding-left-16" style={{ marginTop: -16 }}>
        <div className="row ">
          <div className="form-control col-6">
            <label>Nome do Produto</label>
            <input
              type="text"
              value={form.name}
              onChange={({ target: { value } }): void => setForm(form => ({ ...form, name: value }))}
              required
            />
          </div>

          <div className="form-control col-6">
            <label>
              Categoria
              <i className="fa fa-sync" onClick={fetchCategories} />
            </label>
            <Select
              required
              selected={String(form.category)}
              onSelect={(key): void => setForm({ ...form, category: key })}
              itens={categories.map(({ id, name }) => ({ key: id, value: name }))}
            />
          </div>

          <div className="form-control col-6">
            <label>Ativo?</label>
            <select
              required
              value={form.isActive ? 1 : 0}
              onChange={({ target: { value } }): void => {
                setForm(form => ({ ...form, isActive: parseInt(value) === 1 }))
              }}
            >
              <option value={1}>Sim</option>
              <option value={0}>Não</option>
            </select>
          </div>
          <div className="form-control col-6">
            <label>Listar para compra?</label>
            <select
              required
              value={form.isSellable ? 1 : 0}
              onChange={({ target: { value } }): void => {
                setForm(form => ({ ...form, isSellable: parseInt(value) === 1 }))
              }}
            >
              <option value={1}>Sim</option>
              <option value={0}>Não</option>
            </select>
          </div>
        </div>

      </div>

      <div className="form-control">
        <label>Descrição</label>
        <textarea
          rows={6}
          value={form.description}
          onChange={(e): void => setForm({ ...form, description: e.target.value })}
        />
      </div>

      <div className="row  margin-top-16">
        {
          id && (
            <NavLink
              style={{ width: 200 }}
              className="button secondary margin-lr-8"
              to={`/panel/partner/${partnerId}/product/${id}/config`}
            >
              <i className="fa fa-cogs"/> Configurar
            </NavLink>
          )
        }
        <div className="grow">
          <div className="row justify-end">
            <span className="button primary bordered margin-right-8" onClick={handleClear} style={{ width: 200 }}>
            Limpar
            </span>

            <button className="primary" style={{ width: 200 }}>
              <i className="fa fa-save" /> Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default ProductForm
